import React from "react";
import Col from "react-bootstrap/Col";
import 'react-day-picker/lib/style.css';

import {
    AIRCRAFT_FIELD,
    CANOPY_FIELD,
    COMMENT_FIELD, DATE_FIELD,
    DISTANCE_FROM_TARGET_FIELD,
    DROPZONE_FIELD,
    EXIT_ALTITUDE_FIELD,
    FREEFALL_TIME_FIELD,
    JUMP_NUMBER_FIELD,
    DEPLOY_ALTITUDE_FIELD,
    TITLE_FIELD, WINGSUIT_FIELD
} from "./fields";
import {DateInput, ReadOnlyText, SelectInput, TextInput} from "./input";
import {Field} from "./field/field";
import {IconPicker} from "./icon/icons";
import Row from "react-bootstrap/Row";
import {Icon} from "../common/jump";
import Container from "react-bootstrap/Container";

export function JumpFormReadOnly(props) {
    return (
        <>
            <Col xs={12} sm={12} md={12} lg={6} xl={6}>
                <ReadOnlyText field={new Field(JUMP_NUMBER_FIELD(), props.jumpNumber)}/>
                <ReadOnlyText field={new Field(TITLE_FIELD(), props.title)}/>
                <ReadOnlyText field={new Field(DATE_FIELD(), props.date)}/>
                <ReadOnlyText field={new Field(DROPZONE_FIELD(), props.dropzone)}/>
                <ReadOnlyText field={new Field(AIRCRAFT_FIELD(), props.aircraft)}/>
                <ReadOnlyText field={new Field(COMMENT_FIELD(), props.comment)}/>
            </Col>
            <Col xs={12} sm={12} md={12} lg={6} xl={6}>
                <ReadOnlyText field={new Field(DISTANCE_FROM_TARGET_FIELD(), props.distanceFromTarget)}/>
                <ReadOnlyText field={new Field(FREEFALL_TIME_FIELD(), props.freeFallTime)}/>
                <ReadOnlyText field={new Field(EXIT_ALTITUDE_FIELD(), props.exitAltitude)}/>
                <ReadOnlyText field={new Field(DEPLOY_ALTITUDE_FIELD(), props.deployAltitude)}/>
                <ReadOnlyText field={new Field(CANOPY_FIELD(), props.canopy)}/>
                <ReadOnlyText field={new Field(WINGSUIT_FIELD(), props.wingsuit)}/>
            </Col>
        </>
    )
}

export function JumpForm(props) {
    return (
        <>
            <Col xs={12} sm={12} md={12} lg={6} xl={6}>
                <TextInput focus={true} field={new Field(JUMP_NUMBER_FIELD(), props.jumpNumber)} handleFormChange={props.handleFormChange} index={props.index}/>
                <TextInput field={new Field(TITLE_FIELD(), props.title)} handleFormChange={props.handleFormChange} index={props.index}/>
                <DateInput field={new Field(DATE_FIELD(), props.date)} handleFormChange={props.handleFormChange} index={props.index}/>
                <SelectInput field={new Field(DROPZONE_FIELD(), props.dropzone)}
                    valueById="true"
                    options={props.dictionaries.dropzones}
                    handleFormChange={props.handleFormChange}
                    updateDictionaries={props.updateDictionaries}
                    dictionaries={props.dictionaries}
                    index={props.index}
                />
                <SelectInput field={new Field(AIRCRAFT_FIELD(), props.aircraft)}
                             options={props.dictionaries.aircrafts}
                             creatableCollection="aircrafts"
                             updateDictionaries={props.updateDictionaries}
                             dictionaries={props.dictionaries}
                             handleFormChange={props.handleFormChange}
                             index={props.index}
                />
                <TextInput field={new Field(COMMENT_FIELD(), props.comment)} handleFormChange={props.handleFormChange} index={props.index}/>
            </Col>
            <Col xs={12} sm={12} md={12} lg={6} xl={6}>
                <TextInput field={new Field(DISTANCE_FROM_TARGET_FIELD(), props.distanceFromTarget)} handleFormChange={props.handleFormChange} index={props.index}/>
                <TextInput field={new Field(FREEFALL_TIME_FIELD(), props.freeFallTime)} handleFormChange={props.handleFormChange} index={props.index}/>
                <TextInput field={new Field(EXIT_ALTITUDE_FIELD(), props.exitAltitude)} handleFormChange={props.handleFormChange} index={props.index}/>
                <TextInput field={new Field(DEPLOY_ALTITUDE_FIELD(), props.deployAltitude)} handleFormChange={props.handleFormChange} index={props.index}/>
                <SelectInput field={new Field(CANOPY_FIELD(), props.canopy)}
                    options={props.dictionaries.canopies}
                    creatableCollection="canopies"
                     updateDictionaries={props.updateDictionaries}
                     dictionaries={props.dictionaries}
                    handleFormChange={props.handleFormChange}
                    index={props.index}
                />
                <SelectInput field={new Field(WINGSUIT_FIELD(), props.wingsuit)}
                     options={props.dictionaries.wingsuites}
                     creatableCollection="wingsuites"
                     updateDictionaries={props.updateDictionaries}
                     dictionaries={props.dictionaries}
                     handleFormChange={props.handleFormChange}
                     index={props.index}
                />
            </Col>
            <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                <Container>
                    {props.iconIDs && props.iconIDs.length > 0
                        ? <Row className="icon-negative-margin mt-3">
                            {
                                props.iconIDs.map((icon, index) => (
                                    <Icon name={icon.name} url={icon.url} key={index}/>
                                ))
                            }
                        </Row>
                        : null
                    }
                </Container>
            </Col>
            <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                <IconPicker {...props}/>
            </Col>
        </>
    )
}